import { Link } from "react-router-dom";
import { useGetVideosQuery } from "../../../features/Videos/videosApi";
import VideoItem from "./VideoItem";
import routes from "../../../config/routeConfig";

export default function Videos() {
  const { data: videos, isError, isLoading } = useGetVideosQuery();

  return (
    <div className="px-3 py-20 bg-opacity-10">
      <div className="w-full flex">
        <Link to={routes.admin.addVideo} className="ml-auto">
          <button className="btn">Add Video</button>
        </Link>
      </div>

      <div className="overflow-x-auto mt-4">
        <table className="divide-y-1 text-base divide-gray-600 w-full">
          <thead>
            <tr>
              <th className="table-th">Video Title</th>
              <th className="table-th">Description</th>
              <th className="table-th">Action</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-600/50">
            {isLoading && (
              <tr>
                <td className="text-center" colSpan="100%">
                  Loading videos...
                </td>
              </tr>
            )}
            {isError && (
              <tr>
                <td className="text-center" colSpan="100%">
                  Failed to fetch videos!
                </td>
              </tr>
            )}
            {!isLoading && videos.length === 0 && (
              <tr>
                <td className="text-center" colSpan="100%">
                  No videos found!
                </td>
              </tr>
            )}

            {videos?.map((video) => (
              <VideoItem video={video} key={video.id} />
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
